import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

/**
 * Renders SLP1 analysis units. Normal units (type 'm') are plain; error units are
 * highlighted, show a popover on hover, and open the Help PDFs modal on click.
 */
function SandhiAnalysisSlp1({ slp1Units = [], onOpenHelp }) {
  if (!slp1Units.length) return null;

  return (
    <span className="analysis-units">
      {slp1Units.map((unit, i) => {
        const isError = unit.type !== 'm';
        const popover = unit.popover || {};

        if (!isError) {
          return (
            <span key={i} className="analysis-unit">
              {unit.text}
            </span>
          );
        }

        const isRed = popover.color === 'red';
        const headerBg = isRed ? '#c62828' : '#1565c0';
        const bodyBg = isRed ? '#ffebee' : '#e3f2fd';
        const bodyColor = isRed ? '#b71c1c' : '#0d47a1';
        const spanStyle = isRed
          ? { backgroundColor: 'rgba(244, 67, 54, 0.35)' }
          : { backgroundColor: 'rgba(0, 123, 255, 0.25)' };

        const popoverEl = (
          <Popover id={`analysis-popover-${i}`} className="analysis-popover">
            <Popover.Header as="h3" style={{ backgroundColor: headerBg, color: '#fff', textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word' }}>
              {popover.head ?? 'Error'}
            </Popover.Header>
            <Popover.Body style={{ backgroundColor: bodyBg, color: bodyColor, whiteSpace: 'normal', wordWrap: 'break-word' }}>
              {popover.message ?? ''}
            </Popover.Body>
          </Popover>
        );

        const handleClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof onOpenHelp === 'function') onOpenHelp();
        };

        return (
          <OverlayTrigger
            key={i}
            trigger={['hover', 'focus']}
            placement="top"
            overlay={popoverEl}
          >
            <span
              role="button"
              tabIndex={0}
              className="analysis-unit analysis-unit--error"
              style={{ ...spanStyle, cursor: onOpenHelp ? 'pointer' : undefined }}
              onClick={handleClick}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(e); } }}
            >
              {unit.text}
            </span>
          </OverlayTrigger>
        );
      })}
    </span>
  );
}

export default SandhiAnalysisSlp1;
